var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cashback__container",style:({
		'min-width': _vm.iconWidth,
		'min-height': _vm.iconHeight,
		'max-width': _vm.iconWidth,
		'max-height': _vm.iconHeight,
	})},[_c('img',{staticClass:"cashback__icon",style:({
			'min-width': _vm.iconWidth,
			'min-height': _vm.iconHeight,
			'max-width': _vm.iconWidth,
			'max-height': _vm.iconHeight,
		}),attrs:{"src":"/assets/images/logo_cashback.svg","alt":""},on:{"mouseover":function($event){_vm.isTooltipVisible = true},"mouseleave":function($event){_vm.isTooltipVisible = false},"click":function($event){return _vm._goToCashbackInfo()}}}),(_vm.hasTooltip)?_c('span',{staticClass:"tooltipText",class:{
			visible: _vm.isTooltipVisible,
			top: _vm.position === 'top',
			bottom: _vm.position === 'bottom',
			left: _vm.position === 'left',
			right: _vm.position === 'right'
		},domProps:{"innerHTML":_vm._s(_vm.getTooltipMessage)}},[_vm._v("\n\t\tAún no has probado este producto. "),_c('br'),_c('b',[_vm._v("¡Atrévete!")]),_vm._v(" y si no te\n\t\tgusta, "),_c('b',[_vm._v("te devolvemos tu dinero en cashback.")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }